"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatusRoutes = void 0;
var UserStatusRoutes;
(function (UserStatusRoutes) {
    UserStatusRoutes["BasePrefix"] = "user-statuses";
    UserStatusRoutes["ById"] = ":userStatusId";
    UserStatusRoutes["All"] = "all";
    UserStatusRoutes["List"] = "list";
})(UserStatusRoutes = exports.UserStatusRoutes || (exports.UserStatusRoutes = {}));
